import { useState } from "react";
import { Link } from "react-router-dom";
import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";
import { galleryItems, galleryCategories } from "../../mocks/gallery";

export default function GalleryPage() {
  const [activeCategory, setActiveCategory] = useState("すべて");

  const filtered = activeCategory === "すべて"
    ? galleryItems
    : galleryItems.filter((item) => item.category === activeCategory);

  return (
    <div>
      <Navbar />

      {/* Hero */}
      <section className="relative pt-40 pb-20 bg-[#FAF8F6] text-center overflow-hidden">
        <div className="absolute inset-0 opacity-30">
          <img
            src="https://public.readdy.ai/ai/img_res/7f6650593b8e9684daf19354c7631cf5.jpg"
            alt=""
            className="w-full h-full object-cover object-top"
          />
        </div>
        <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-10">
          <p className="text-[#B8956A] text-xs tracking-[0.3em] uppercase mb-3" style={{ fontFamily: "'Noto Serif JP', serif" }}>Gallery</p>
          <h1 className="text-4xl lg:text-5xl text-[#3D2E2A] mb-4" style={{ fontFamily: "'Noto Serif JP', serif", fontWeight: 300 }}>
            施術ギャラリー
          </h1>
          <p className="text-[#8B7355] text-sm max-w-md mx-auto" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
            BE:NAILが手がけた施術作品をご覧ください。あなたのイメージ作りの参考にどうぞ。
          </p>
        </div>
      </section>

      {/* Filter Tabs */}
      <section className="bg-white border-b border-[#EDE7DF] sticky top-20 z-30">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-4 flex items-center gap-2 overflow-x-auto">
          {galleryCategories.map((cat) => (
            <button
              key={cat}
              onClick={() => setActiveCategory(cat)}
              className={`px-5 py-2 rounded-full text-xs tracking-wider whitespace-nowrap cursor-pointer transition-all ${
                activeCategory === cat
                  ? "bg-[#3D2E2A] text-white"
                  : "border border-[#EDE7DF] text-[#8B7355] hover:border-[#B8956A] hover:text-[#B8956A]"
              }`}
              style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
            >
              {cat}
            </button>
          ))}
        </div>
      </section>

      {/* Gallery Grid */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
            {filtered.map((item) => (
              <div
                key={item.id}
                className={`rounded-xl overflow-hidden border border-[#EDE7DF] relative group cursor-pointer ${
                  item.aspect === "portrait" ? "row-span-2" : ""
                }`}
              >
                <div className={`w-full ${item.aspect === "portrait" ? "h-[420px]" : "h-52"} overflow-hidden`}>
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-4">
                  <div>
                    <span className="text-[#C9A86A] text-xs tracking-wider block mb-1" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
                      {item.category}
                    </span>
                    <p className="text-white text-sm font-medium" style={{ fontFamily: "'Noto Serif JP', serif" }}>{item.title}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {filtered.length === 0 && (
            <div className="text-center py-20 text-[#8B7355]" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
              該当するギャラリーがありません
            </div>
          )}
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 bg-[#FAF8F6] text-center">
        <p className="text-[#B8956A] text-xs tracking-[0.3em] uppercase mb-3" style={{ fontFamily: "'Noto Serif JP', serif" }}>Book Now</p>
        <h2 className="text-3xl text-[#3D2E2A] mb-4" style={{ fontFamily: "'Noto Serif JP', serif", fontWeight: 300 }}>
          気になるデザインがありましたか？
        </h2>
        <p className="text-[#8B7355] text-sm mb-8" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
          ご来店の際にお気に入りのデザインをお伝えください
        </p>
        <Link
          to="/booking"
          className="inline-flex items-center gap-2 bg-[#B8956A] text-white px-10 py-4 rounded-full text-sm tracking-widest hover:bg-[#A07B55] transition-colors cursor-pointer whitespace-nowrap"
          style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
        >
          <span className="w-4 h-4 flex items-center justify-center"><i className="ri-calendar-2-line text-sm" /></span>
          ご予約はこちら
        </Link>
      </section>

      <Footer />
    </div>
  );
}
